import React from 'react'

export default function Errortext(props) {
  return (
    <div style={{color:'red'}}>
        {props.children}
    </div>
  )
}
